<template>
  <div class="bg-white rounded-2xl p-7 border border-[#1c4848]/10 shadow-sm" :class="[wrapperClass]">
    <div class="flex items-center justify-between mb-6">
      <div>
        <h3 class="text-[20px] font-medium tracking-tight text-[#1c4848]">{{ title }}</h3>
        <p class="text-[15px] text-[#1c4848]/55 mt-1">
          {{ subtitle }}
        </p>
      </div>
      <span class="text-[13px] font-medium px-2 py-1 rounded-lg text-[#1c4848] bg-[#1c4848]/5">
        {{ rows.length }} types
      </span>
    </div>

    <p v-if="!rows.length" class="text-base text-[#1c4848]/40 py-8 text-center">
      Nothing logged in this period yet.
    </p>

    <div v-else class="overflow-x-auto -mx-2">
      <table class="w-full min-w-[420px]">
        <thead>
          <tr class="text-left">
            <th class="px-2 pb-3 text-[13px] font-semibold text-[#1c4848]/45">Event</th>
            <th class="px-2 pb-3 text-[13px] font-semibold text-[#1c4848]/45 text-right">Users</th>
            <th class="px-2 pb-3 text-[13px] font-semibold text-[#1c4848]/45 text-right">Total</th>
            <th class="px-2 pb-3 w-1/3"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in visibleRows" :key="row.key" class="border-t border-[#1c4848]/5">
            <td class="px-2 py-3">
              <p class="text-lg font-medium text-[#1c4848]">{{ row.label }}</p>
              <p class="text-[13px] text-[#1c4848]/30 font-mono">{{ row.key }}</p>
            </td>
            <td class="px-2 py-3 text-right text-lg text-[#1c4848]/70">{{ formatNumber(row.users) }}</td>
            <td class="px-2 py-3 text-right text-[19px] font-semibold text-[#1c4848]">{{ formatNumber(row.total) }}</td>
            <td class="px-2 py-3">
              <div class="w-full h-3 rounded-full bg-[#1c4848]/5 overflow-hidden">
                <div
                  class="h-full rounded-full bg-[#1c4848]/70"
                  :style="{ width: `${Math.max(share(row), 2)}%` }"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <button
        v-if="rows.length > limit"
        class="mt-4 text-base font-bold text-[#1c4848]/60 hover:text-[#1c4848] transition-colors"
        @click="expanded = !expanded"
      >
        {{ expanded ? 'Show less' : `Show all ${rows.length}` }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  title: { type: String, default: 'Everything Being Logged' },
  subtitle: { type: String, default: 'All recorded events in this period' },
  rows: { type: Array, default: () => [] },
  limit: { type: Number, default: 8 },
  wrapperClass: { type: String, default: '' },
});

const expanded = ref(false);

const visibleRows = computed(() => (expanded.value ? props.rows : props.rows.slice(0, props.limit)));

const maxTotal = computed(() => props.rows.reduce((max, row) => Math.max(max, row.total || 0), 0));

function share(row) {
  if (!maxTotal.value) return 0;
  return (row.total / maxTotal.value) * 100;
}

function formatNumber(value) {
  return new Intl.NumberFormat('en-US').format(value ?? 0);
}
</script>
